<template>
  <div class="my-account">
    <Header :title="{name: '账户余额'}" :goBackHandler="goBack">
      <div slot="right-sum"
           @click="onDetial">常见问题</div>
    </Header>
    <div class="content">
      <p class="price">{{balance | toFixPrice}}</p>
      <p class="title">余额（元）</p>
      <p class="btn"
         @click="onRecharge">支付宝提现</p>
    </div>
    <van-tabs v-model="active"
              title-inactive-color="#333333"
              line-width="56"
              :title-active-color="$theme_color">
      <van-tab v-for="(item,index) in tabs"
               :key="index"
               :title="item.name"></van-tab>
    </van-tabs>
    <!-- 余额记录/提现记录 -->
    <div class="account_record">
      <!-- 余额明细 -->
      <ul class="detail"
          v-if="active==0">
        <empty class="emptyImg"
               v-if="balanceDetail.length == 0"
               :empty_type="emptyType"></empty>
        <li class="detail_item"
            v-for="(item,index) in balanceDetail"
            :key="index">
          <div>
            <p class="remark">{{item.remark}}</p>
            <p class="time">{{item.created_at}}</p>
          </div>
        </li>
      </ul>
      <!-- 提现记录 -->
      <ul class="withdraw"
          v-if="active==1">
        <empty class="emptyImg"
               v-if="transferRecord.length == 0"
               :empty_type="emptyType"></empty>
        <li class="item"
            @click="toTransferDetail(index)"
            v-for="(item,index) in transferRecord"
            :key="index">
          <div>
            <p>
              <span class="lable">审核状态：</span>
              <span v-if="item.status==1"
                    class="status pass">已通过</span>
              <span v-if="item.status==2"
                    class="status nopass">未通过</span>
              <span v-if="item.status==3"
                    class="status">待审核</span>
            </p>
            <p class="time">
              {{item.audit_at}}
            </p>
          </div>
          <div class="count">
            +{{item.amount | toFixPrice}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import empty from "@/components/Empty";
import emptyImg from '@/assets/images/answer_empty.png';
import Header from '@/components/Header'
export default {
  name: 'my-account',
  components: {
    Header,
    empty
  },
  data () {
    return {
      emptyType: { name: '暂无数据', img: emptyImg },
      balance: 0,
      active: 0,
      min_amount: 0,
      tabs: [{ name: '余额明细', id: 1 }, { name: '提现记录', id: 2 }],
      balanceDetail: [],
      transferRecord: []
    }
  },
  created () {
    this.requestData();
    this.getTransferRecord();
    // let _this = this;
    // setTimeout(() => {
    //   _this.$pub.registerWebViewJavascriptBridge(() => {
    //     _this.requestData();
    //   });
    // }, 500);
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    // on event
    onDetial () {
      this.$router.push({
        name: 'CommonProblem'
      })
    },
    onRecharge () {
      // this.$pub.InAppPage('MyIntergral')
      if (this.balance < this.min_amount) {
        this.$toast('满' + this.min_amount + '元才能提现');
      } else {
        this.$router.push({
          name: 'Withdraw'
        })
      }
    },
    // request
    requestData () {
      this.$http.get('/api/app/balanceCenter').then(data => {
        this.balance = data.balance;
        this.min_amount = data.min_amount;
        this.balanceDetail = data.balanceDetail.list;
      })
    },
    getTransferRecord () {
      this.$http.post('/api/app/account/transferRecord').then(data => {
        console.log(data)
        this.transferRecord = data.list;
      })
    },
    toTransferDetail (index) {
      this.$router.push({
        name: 'TransferDetail',
        query: { index: index }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-account {
  @extend %default-bg;
  background-color: #fff;
  font-family: PingFang SC;
  .content {
    height: 204px;
    background: linear-gradient(
      -36deg,
      rgba(59, 144, 255, 1),
      rgba(134, 186, 252, 1)
    );
    text-align: center;
    padding: 70px 0;
    .title {
      font-size: 24px;
      color: #ffffff;
      margin-top: 30px;
    }
    .price {
      font-size: 48px;
      color: #ffffff;
      font-weight: 500;
    }
    .btn {
      background-color: #ffffff;
      width: 200px;
      height: 66px;
      border-radius: 4px;
      font-size: 30px;
      color: $theme_color;
      line-height: 66px;
      margin: 40px auto 0 auto;
    }
  }
  .account_record {
    color: #333;
    font-size: 28px;
    padding: 31px;
    padding-top: 0;
    .detail_item {
      .remark {
        font-size: 24px;
        line-height: 38px;
      }
      .time {
        margin-top: 17px;
        color: #7c7c7c;
        font-size: 24px;
      }
      border-bottom: 1px solid #f6f6f6;
      padding: 31px 0;
      &:last-child {
        border: 0;
      }
    }
    .item {
      height: 122px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f6f6f6;
      .time {
        margin-top: 17px;
        color: #7c7c7c;
        font-size: 24px;
      }
      .count {
        font-weight: 500;
        font-size: 30px;
      }
      .status {
        color: #fc0d1b;
      }
      .pass {
        color: #333333;
      }
      .nopass {
        color: #999999;
      }
    }
  }
  .emptyImg {
    padding: 100px 0;
    /deep/ img {
      width: 128px;
      height: 128px;
    }
  }
}
</style>